import React, { useState, useCallback, useEffect } from 'react';
import Sidebar from './Sidebar';
import TopBar from './TopBar';
import { LayoutWrapper, MainArea, ContentArea } from './Layout.styles';

const TABLET_BREAKPOINT = 768;

const Layout = ({ children, currentUser, companyStore, adminStore, onCompanyChange, onAddBusinessLine, onLogout, selectedCompanyId, history }) => {
  const [collapsed, setCollapsed] = useState(false);
  const [mobileOpen, setMobileOpen] = useState(false);

  // Close mobile sidebar on resize past breakpoint
  useEffect(() => {
    const onResize = () => {
      if (window.innerWidth > TABLET_BREAKPOINT) setMobileOpen(false);
    };
    window.addEventListener('resize', onResize);
    return () => window.removeEventListener('resize', onResize);
  }, []);

  const handleMobileClose = useCallback(() => setMobileOpen(false), []);
  const handleMenuToggle = useCallback(() => setMobileOpen(prev => !prev), []);

  return (
    <LayoutWrapper>
      <Sidebar
        collapsed={collapsed}
        onToggle={() => setCollapsed(!collapsed)}
        mobileOpen={mobileOpen}
        onMobileClose={handleMobileClose}
        currentUser={currentUser}
        companyStore={companyStore}
        onLogout={onLogout}
        history={history}
      />
      <MainArea $collapsed={collapsed}>
        <TopBar
          currentUser={currentUser}
          companyStore={companyStore}
          adminStore={adminStore}
          onCompanyChange={onCompanyChange}
          onAddBusinessLine={onAddBusinessLine}
          selectedCompanyId={selectedCompanyId}
          onMenuToggle={handleMenuToggle}
        />
        <ContentArea data-tour-scroll="content">
          {children}
        </ContentArea>
      </MainArea>
    </LayoutWrapper>
  );
};

export default Layout;
